import logger from 'src/utils/logger/logger';
const regexWebvttClassTagOpen = /<\/?c\.[a-z]+>/; // matches <c.color> tag
const regexWebvttClassTagClose = /<\/c>/; // matches </c> tag

class SubtitlesParser {

  //[line:78%, position:50%, align:middle... etc] to css styles
  static parseStyleConfig(style, defaultStyle) {
    var colonIdx = style.indexOf(':');
    var key = style.substring(0, colonIdx);
    var value = style.substring(colonIdx + 1).trim();
    let newStyles = {};

    switch (key) {
      // For crackle :/
      // Example: 00:08:15.210 --> 00:08:17.120 A:end T:10% L:75%
      case "T":
        newStyles.top = defaultStyle.top;
        newStyles.bottom = defaultStyle.bottom;
        newStyles.line = defaultStyle.line;
        break;
      case "L":
        newStyles.left = defaultStyle.left;
        break;
      case "A":
        newStyles.textAlign = defaultStyle.textAlign;
        break;

      case "line":
        let offset = 0;
        const line = parseInt(value);

        if (value.indexOf('%') != -1) {
          offset = (line > parseInt(defaultStyle.line)) ? defaultStyle.line : value;
        } else {
          offset = (line * 100) / 16;
          offset = `${offset}%`;
        }

        if (line > 0) {
          newStyles.top = offset;
          newStyles.bottom = defaultStyle.bottom;
        } else {
          newStyles.bottom = 'initial';
          newStyles.top = '80%';
        }
        newStyles.line = "" + value;
        break;
      case "align":
        if (value === "middle") value = 'center';
        newStyles.textAlign = value;
        break;

      case "position":
        let pos = 0;
        if (value.indexOf('%') != -1) {
          pos = parseInt(value);
          if (pos == 50)
            pos = 0;
          else if (pos > 50)
            pos = 100 - pos;
          else
            pos = (50 - pos) * -1;
        }
        else
          pos = value;

        newStyles.left = pos;
        break;

      case "size":
        newStyles.width = value;
        break;

      default:
        // Nothing to do
        break;
    }

    return newStyles;
  }

  static parseStyles(vttStyles) {
    const defaultStyle = {
      top: '80%',
      bottom: 'initial',
      line: '80%',
      left: '0',
      textAlign: 'center'
    };
    var newStyles = Object.assign({}, defaultStyle);

    for (var i = 0; i < vttStyles.length; i++) {
      var newStyleConfig = this.parseStyleConfig(vttStyles[i], defaultStyle);
      Object.assign(newStyles, newStyleConfig);
    }

    return newStyles;
  }

  //00:02:03.100 to milliseconds
  static timeString2ms(timeString) {
    const arrTime = timeString.split('.');
    const ms = arrTime[1] * 1 || 0;
    const hms = arrTime[0].split(':'); //array hh mm ss
    let calculatedMs = 0;
    if (hms[2]) {
      calculatedMs = hms[0] * 3600 + hms[1] * 60 + hms[2] * 1;
    } else if (hms[1]) {
      calculatedMs = hms[0] * 60 + hms[1] * 1;
    } else {
      calculatedMs = hms[0] * 1;
    }

    // return calculatedMs * 1e3;
    return ms + calculatedMs * 1e3;

  }

  /**
   * Checks if a string has <c.color> and </c> tags
   *
   * @param {string} string the string to check
   */
  static hasWebVttClassObject(string) {
    return regexWebvttClassTagOpen.test(string) && regexWebvttClassTagClose.test(string);
  }

  /**
   * Replaces <c.color> and </c> with <span class="color"> and </span> tags
   *
   * @param {string} string the string to parse
   * @return {string} the parsed string
   */
  static parseWebVttClassObject(string) {
    // replaces WebVtt class object (<c.color></c>) (color is variable)
    // https://w3c.github.io/webvtt/#webvtt-class-object

    const openningTag = string.match(regexWebvttClassTagOpen)[0];
    let color = openningTag.split(".")[1]; // color>
    color = color.substring(0, color.length - 1); // remove the >

    let parsed = string
      .replace(regexWebvttClassTagOpen, '<span class="' + color + '">')
      .replace(regexWebvttClassTagClose, '</span>');

    return parsed;
  }

  static isHBOEndVTTFile(line) {
    return line.indexOf('*END') > -1;
  }

  static convertVttToArray(vttString) {
    if (typeof vttString !== 'string') return [];

    var start = false;
    var current = {};
    var sections = [];
    var styles = [];
    var isBlankLine = false;
    var isEndVTT = false;

    var vttArray = vttString.split('\n');
    var totalLines = vttArray.length;

    // for loop en lugar de forEach: evita el overhead del closure en cada iteración
    for (var index = 0; index < totalLines; index++) {
      var line = vttArray[index];

      if (line.trim().length === 0) {
        // Para End VTT en subtítulos Crackle
        if (isBlankLine && (totalLines - 1) === index && current) {
          if (current.start && !isEndVTT) {
            sections.push(current);
          }
        }
        isBlankLine = true;
      }

      if (index === 2 && /position|line/.test(line)) {
        // ignorar la primera línea porque viene mal
      } else if (this.isHBOEndVTTFile(line)) {
        // Para End VTT en subtítulos HBO
        if (current && current.start) {
          isEndVTT = true;
        }
        sections.push(current);
      } else if (line.indexOf('-->') !== -1) {
        // Línea de timestamp — path más frecuente, se revisa antes que el regex
        start = true;

        if (current.start) {
          sections.push(current);
          isBlankLine = false;
        }

        var times = line.split(' --> ');
        var startTime = times.shift();
        var endTimeWithStylesMaybe = times.shift().split(' ');
        var endTime = endTimeWithStylesMaybe.shift();
        styles = endTimeWithStylesMaybe.slice(0);

        try {
          current = {
            start: this.timeString2ms(startTime),
            end: this.timeString2ms(endTime),
            part: '',
            styles: this.parseStyles(styles)
          };
        } catch (e) {
          logger.error('[MULTIAUDIO]: line ' + line);
          logger.error(e);
        }

      } else if (!isNaN(line)) {
        // número de cue — ignorar
      } else {
        // Calcular strippedLine una sola vez en lugar de 4 veces
        var strippedLine = line.replace(/<\/?[^>]+(>|$)/g, '');
        if (strippedLine === ' ' || strippedLine === '') {
          // línea vacía o que solo contiene tags HTML — ignorar
        } else if (start) {
          if (this.hasWebVttClassObject(line)) {
            line = this.parseWebVttClassObject(line);
          }
          if (current && current.part !== undefined && current.part.length === 0) {
            current = Object.assign({}, current, { part: line });
          } else {
            current = Object.assign({}, current, { part: current.part + '<br/>' + line });
          }
          // Si es la última línea de los subtítulos
          if (index === totalLines - 1) {
            sections.push(current);
            isBlankLine = false;
          }
        }
      }
    }

    return sections;
  }

}

export default SubtitlesParser;



// WEBPACK FOOTER //
// ./src/utils/SubtitlesParser.js